'use client'

import { MasterclassButton } from '@/MasterclassButton'

export const SimpleCTASection = () => {
  return (
    <section className="py-6 md:py-8">
      <div className="text-center">
        <div className="inline-block h-8 border-l border-vi-gray mb-4"></div>
        <div className="py-4">
          <MasterclassButton className="bg-vi-red text-white px-6 py-3 rounded-md font-semibold hover:bg-vi-red-dark transition-colors" />
        </div>
        <div className="inline-block h-8 border-l border-vi-gray mt-4"></div>
      </div>
    </section>
  )
}
